module.exports = __webpack_public_path__ + "img/130.5960d03a.jpg";